import _ from 'lodash';
import walletService from '@/services/walletService';
import Wallet from '../../model/wallet';

const state = {
  baseUrl: '/wallet',
  wallets: [],
  pagination: {},
  wallet: null,
  loading: false
};

const actions = {
  list({ dispatch, commit }, { type = 'wallet', query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    commit('setWallets', { wallets: [], pagination: {} });

    walletService
      .list({ type, query })
      .then(response => {
        commit('setWallets', { wallets: response.data.rows, pagination: response.data.pagination });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  getOne({ dispatch, commit }, { type = 'wallet', walletId, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    commit('setWallet', { wallet: {} });

    walletService
      .getOne({ type, walletId })
      .then(response => {
        commit('setWallet', { wallet: response.data });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  postOne({ dispatch, commit }, { type = 'wallet', wallet, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    walletService
      .postOne({ type, wallet })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'bottom-end',
            title: '',
            text: type === 'wallet' ? 'New wallet has been added.' : 'New wallet has been added.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  patchOne({ dispatch, commit }, { type = 'wallet', walletId, wallet, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    walletService
      .patchOne({ type, walletId, newWallet: wallet })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'bottom-end',
            title: '',
            text: type === 'wallet' ? 'Wallet has been updated.' : 'Wallet has been updated.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  deleteOne({ dispatch, commit }, { type = 'wallet', walletId, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    walletService
      .deleteOne({ type, walletId })
      .then(_response => {
        dispatch('list', { type });
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'bottom-end',
            title: '',
            text: type === 'wallet' ? 'Wallet has been deleted.' : 'Wallet has been deleted.'
          },
          { root: true }
        );
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  }
};

const getters = {};

const mutations = {
  startRequest(state) {
    state.loading = true;
  },
  requestFailed(state) {
    state.loading = false;
  },
  setWallets(state, { wallets, pagination }) {
    let rowNum = pagination.first_row_no;
    state.wallets = _.map(wallets, wallet => {
      const newWallet = new Wallet({
        rowNum,
        id: wallet.id,
        mnemonic: wallet.mnemonic,
        address: wallet.address,
        addressTransfers: wallet.address_transfers,
        pubkey: wallet.pubkey,
        cardLinkedAt: wallet.card_linked_at,
        chipLinkedAt: wallet.chip_linked_at,
        mobileLinkedAt: wallet.mobile_linked_at,
        status: wallet.status,
        enabled: wallet.enabled,
        enabledName: wallet.enabled_name,
        createdAt: wallet.created_at,
        updatedAt: wallet.updated_at
      });

      rowNum -= 1;
      return newWallet;
    });
    state.pagination = pagination;

    state.loading = false;
  },
  setWallet(state, { wallet }) {
    state.wallet = new Wallet({
      id: wallet.id,
      mnemonic: wallet.mnemonic,
      address: wallet.address,
      addressTransfers: wallet.address_transfers,
      pubkey: wallet.pubkey,
      cardLinkedAt: wallet.card_linked_at,
      chipLinkedAt: wallet.chip_linked_at,
      mobileLinkedAt: wallet.mobile_linked_at,
      status: wallet.status,
      enabled: wallet.enabled,
      enabledName: wallet.enabled_name,
      createdAt: wallet.created_at,
      updatedAt: wallet.updated_at
    });

    state.loading = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
